<template>
  <div style="padding: 15px;box-sizing: border-box;">
    <!--  通用条款  -->
    <div class="general" v-if="query.contractNo">
      <p>通用条款</p>
      <p class="generalTitle">一、合同解除</p>
      <p>双方依照以下内容执行,<span style="color: red;">若您同意请勾选：</span></p>
      <div class="checkboxItem">
        <van-checkbox v-model="checked1" :disabled="query.signState === 19502" shape="square" style="float: left;"></van-checkbox>
        <p><span>01：</span>甲方预付资金余额不足以支付一次消费的，并未按约定支付余款的，只可享受首次实 际付款数额相应的优惠幅度。</p>
      </div>
      <div class="checkboxItem">
        <van-checkbox v-model="checked2" :disabled="query.signState === 19502" shape="square" style="float: left;"></van-checkbox>
        <p><span>02：</span>乙方变更服务地点、调整主要经营项目、擅自提高价格或增加服务限制条件严重影响 甲方利益的，双方应当协商解决；协商不成的，甲方可以解除合同，并要求乙方按照以下标 准在扣除已消费金额后，一次性返还预付合同余额：
          ( 1 )双方约定甲方享受单次服务价格优惠的，已消费金额应当按照约定的优惠价格计算。 ( 2 ) 双方约定甲方享受明确的赠送金额或服务项目的，单次服务价格的优惠折扣率为  预付费用总额÷ (赠送金额或赠送服务的折算金额＋预付费用总额) × 100%。
          ( 3 ) 双方约定甲方在有效期限内不限次享受服务的， 已消费金额计算方式为：
          合同生效之日起至合同解除之日止的天数÷有效期限内天数× 100%×预付费用总额。</p>
      </div>
      <div class="checkboxItem">
        <van-checkbox v-model="checked3" :disabled="query.signState === 19502" shape="square" style="float: left;"></van-checkbox>
        <p><span>03：</span>除不可抗力外，因乙方原因暂停营业超过30天和歇业，甲方要求解除合同的，乙方应当按照前述标准扣除已消费金额后，一次性返还预付费用余额；甲方不要求解除合同的，有效期限相应顺延或由双方另行协商解决办法。</p>
      </div>
      <div class="checkboxItem">
        <van-checkbox v-model="checked4" :disabled="query.signState === 19502" shape="square" style="float: left;"></van-checkbox>
        <p><span>04：</span>因乙方转让或注销需解除合同的，按照前述标准扣除已消费金额后，一次性返还预付费用余额。</p>
      </div>
      <div class="checkboxItem">
        <van-checkbox v-model="checked5" :disabled="query.signState === 19502" shape="square" style="float: left;"></van-checkbox>
        <p><span>05：</span>双方约定的退款期限为     天，没有约定或者约定不明确的，乙方应当自甲方提出退款要求之日起十五日内退回预收款。</p>
      </div>
      <p class="generalTitle">二、适用范围</p>
      <p>本合同主要适用于向消费者提供零售、餐饮、美容美发和家政等居民服务业各类项目服 务的经营单位与消费者之间发生的单用途预付卡服务交易。</p>
      <p class="generalTitle">三、双方主要权利和义务</p>
      <p>1.甲方有权了解经营者备案及预收资金存管情况。</p>
      <p>2.甲方有权向经营者全面了解预付卡所兑付的商品或者服务内容、数量和质量、价格和费用、有效期限、余额退回、风险警示、违约责任、争议解决等信息。</p>
      <p>3.甲方在有效期内未使用完本合同内金额的，可向乙方要求延期，双方可协商重新约定使用期限、优惠幅度等内容。</p>
      <p>4.甲方应当按时、足额交纳本合同金额。甲方预付余额不足支付当次消费，甲方可以补足金额，并一次性享受原优惠幅度。</p>
      <p>5.乙方在介绍服务项目时应向甲方说明该项目的商品与服务标准、合法经营证明文件、公示价格和有效期、卡的类别和功能以及使用方式等内容。</p>
      <p>6.乙方应当自交易完成之日起保存交易记录至少三年。</p>
      <p>7.乙方对收集的甲方个人信息必须严格保密，不得泄露、出售或者非法向他人提供。</p>
      <p class="generalTitle">四、合同变更与转让</p>
      <p>1.在合同期限内，乙方不得仅因其名称的变更或者法定代表人、负责人、承办人的变动而不履行约定义务。</p>
      <p>2.在合同期限内， 乙方将合同约定的服务项目和内容转让给第三人时，应经甲方同意。甲方在合理期限内未作表示的，视为不同意。</p>
      <p class="generalTitle"> 五、合同效力及组成</p>
      <p>1.本合同自双方签字盖章之日起生效。</p>
      <p>2.未尽事宜，双方按照有关法律法规执行。</p>
      <p>3.执行本合同文本的规定，不影响双方依据有关法律提出保障其他权益的请求。</p>
    </div>
    <div class="agreementWarp">
      <img :src="query.agreementTemplate" alt="" @click="showModel = true">
      <div class="signature" v-if="+query.signState === 19501">
        <p>签字处</p>
        <div class="signatureBtn">
          <van-button color="#ee0a24" type="primary" plain size="small" @click="handleReset">清空</van-button>
          <van-button type="info" size="small" @click="handleGenerate">提交</van-button>
        </div>
        <div class="noticeEsign">
          <vue-esign
            ref="esign"
            :isCrop="isCrop"
            :bgColor="bgColor"
            :lineWidth="lineWidth"
            :lineColor="lineColor"
            style="margin: 5px;border: 1px solid #cccccc;width: 667px !important;height: 240px !important;"/>
        </div>
      </div>
    </div>
    <!--  办卡明细  -->
    <div class="cardDetali" v-if="query.contractNo">
      <p>【办卡明细】</p>
      <div>
        <p style="margin: 15px 0;">合计金额：{{ query.allAmount }}元</p>
        <div class="cardContent" v-for="(item, index) in query.amountJson" :key="index">
          <div class="cardContent_item">
            <p>卡号：</p>
            <p>{{ item.vipNumber }}</p>
          </div>
          <div class="cardContent_item">
            <p>储值账户：</p>
            <p>{{ item.amount }}</p>
          </div>
          <div class="cardContent_item">
            <p>卡名：</p>
            <p>{{ item.vipTypeName }}</p>
          </div>
<!--          <div class="cardTable">-->
<!--            <p>卡号</p>-->
<!--            <p>储值账户</p>-->
<!--            <p>卡名</p>-->
<!--          </div>-->
<!--          <div class="cardTable_item">-->
<!--            <p>{{ item.vipNumber }}</p>-->
<!--            <p>{{ item.amount }}</p>-->
<!--            <p>{{ item.vipTypeName }}</p>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <!--  可消费门店列表  -->
    <div class="shopWarp" :style="query.signState === 19501? 'padding-bottom: 245px;' : 'padding-bottom: 0px;'">
      <div class="title" v-if="shopList.length > 0">本卡可消费门店</div>
      <div class="shopContent" v-for="(item, index) in shopList" :key="index">
        <div>
          <p>{{ item.shopName }}</p>
          <p>{{ item.firstPhone }}</p>
        </div>
        <p>{{ item.address }}</p>
      </div>
    </div>
    <Model :show="showModel">
      <div class="modelWarp">
        <img :src="query.agreementTemplate" alt="">
        <p>{{ query.contractNo }}</p>
        <p v-if="query.customerAmount">{{ query.customerAmount / 100 }}</p>
        <p>{{ query.year }}</p>
        <p>{{ query.month }}</p>
        <p>{{ query.date }}</p>
        <p>{{ query.discountRange }}</p>
        <p>{{ query.customerPhone }}</p>
        <p v-if="query.signState === 19502">{{ query.signYear }}</p>
        <p v-if="query.signState === 19502">{{ query.signMonth }}</p>
        <p v-if="query.signState === 19502">{{ query.signDate }}</p>
        <img v-if="query.signState === 19502" class="customerSign" :src="query.customerSign" alt="">
        <p class="cash" v-if="showCash">√</p>
        <p class="other" v-if="showOther">√</p>
        <p class="otherContent" v-if="showOther">{{ query.configName }}</p>
        <van-button plain @click="showModel = false" class="modelBtn">关闭</van-button>
      </div>
    </Model>
  </div>
</template>

<script>
import { getAgreementDetails, getTemporaryToken, baseCenterUploadImage,
  submitAgreementContent, getConsumptionShop, getAllShopList } from '@/api/agreement'
import { formatDate } from '@/libs/util'
import Model from '@/components/modal'
export default {
  data () {
    return {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      showModel: false,
      query: {},
      showCash: false,
      showOther: false,
      lineWidth: 2,
      lineColor: '#000000',
      bgColor: '#FFFFFF',
      isCrop: true,
      allShopList: [],
      shopList: []
    }
  },
  components: { Model },
  created () {
    if (!this.$route.params.paymentId) {
      this.$toast('刷新后页面中的办卡信息已失效，请重新点击链接进入此页面')
      return
    }
    if (localStorage.getItem('token')) {
      this.getAgreement()
    } else {
      this.getLsToken()
    }
  },
  methods: {
    onChange (event) {
      console.log(event)
    },
    /* 获取全部营业中门店 */
    getAllOpenShopList () {
      let data = {
        rows: 9999,
        businessStatus: '23001'
      }
      let promise = getAllShopList(this, data)
      promise.then((result) => {
        this.allShopList = result.data.list
        this.getConsumptionShopList()
      })
    },
    /* 获取该卡类可消费门店 */
    getConsumptionShopList () {
      let data = {
        classId: this.query.vipType,
        classBrandId: this.query.brandId
      }
      let promise = getConsumptionShop(this, data)
      promise.then((result) => {
        this.shopList = []
        /* 所有门店 */
        if (result.data.allowConsumeShopType === 61101) {
          this.shopList = this.allShopList
        } else if (result.data.allowConsumeShopType === 61102) {
          /* 部分门店 */
          this.allShopList.forEach((item) => {
            result.data.allowConsumeShopList.forEach((shop) => {
              if (+item.shopId === +shop.shopId) {
                shop.shopName = item.shopName
                shop.address = item.address
                shop.firstPhone = item.firstPhone
              }
            })
          })
          this.shopList = result.data.allowConsumeShopList
        } else if (result.data.allowConsumeShopType === 61103) {
          this.allShopList.forEach((item) => {
            if (+this.query.shopId === item.shopId) {
              let obj = {
                shopId: item.shopId,
                shopName: item.shopName,
                address: item.address,
                firstPhone: item.firstPhone
              }
              this.shopList.push(obj)
            }
          })
        }
      })
    },
    /* 提交签署 */
    submitAgreement () {
      let data = {
        shopId: this.query.shopId,
        paymentId: this.query.paymentId,
        signState: '19502',
        customerSign: this.query.customerSign,
        signDate: formatDate(new Date(), 'yyyy-MM-dd')
      }
      let promise = submitAgreementContent(this, data)
      promise.then((result) => {
        if (result.code === 200) {
          this.$router.push({
            name: 'hint'
          })
        }
      })
    },
    // 清空画布
    handleReset () {
      this.$refs.esign.reset()
    },
    // 生成签名的base64图片
    handleGenerate () {
      if (!this.checked1 || !this.checked2 || !this.checked3 || !this.checked4 || !this.checked5) {
        this.$toast('请【勾选】通用条款后再提交！')
        return
      }
      this.$refs.esign.generate().then(res => {
        let file = this.base64ImgtoFile(res)
        let reader = new FileReader()
        let data = new FormData()
        reader.readAsDataURL(file)
        reader.onload = () => {
          data.append('imageDir', 'autograph')
          data.append('imageFile', file)
          let promise = baseCenterUploadImage(this, data)
          promise.then((result) => {
            this.query.customerSign = result.data
            this.submitAgreement()
          })
        }
      }).catch(err => {
        console.log(err)
        this.$toast('签字不能为空！')
      })
    },
    // base64转化成图片
    base64ImgtoFile (dataurl, fileName = 'file') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${fileName}.${suffix}`, { type: mime })
    },
    /* 获取token */
    getLsToken () {
      let vm = this
      let data = {
        signType: 'account_login'
      }
      let promise = getTemporaryToken(vm, data)
      promise.then((res) => {
        localStorage.setItem('token', res.data)
        this.token = res.data
        this.getAgreement()
      })
    },
    getAgreement () {
      let data = {
        paymentId: this.$route.params.paymentId
      }
      let promise = getAgreementDetails(this, data)
      promise.then((result) => {
        if (result.data) {
          result.data.time = result.data.paymentDate.split('-')
          result.data.year = result.data.time[0]
          result.data.month = result.data.time[1]
          result.data.date = result.data.time[2]
          if (result.data.signState === 19502) {
            this.checked1 = true
            this.checked2 = true
            this.checked3 = true
            this.checked4 = true
            result.data.signTime = result.data.signDate.split('-')
            result.data.signYear = result.data.signTime[0]
            result.data.signMonth = result.data.signTime[1]
            result.data.signDate = result.data.signTime[2]
          }
          result.data.paymentMethod = JSON.parse(result.data.paymentMethod)
          if (result.data.paymentMethod.length > 0) {
            result.data.paymentMethod.forEach((item) => {
              /* 合同显示的支付方式 */
              if (+item.configCode === 10320) {
                this.showCash = true
              }
              if (+item.configCode === 10300) {
                this.showOther = true
                result.data.configName = item.configName
              }
            })
          }
          result.data.amountJson = JSON.parse(result.data.amountJson)
          result.data.allAmount = 0
          if (result.data.amountJson.length > 0) {
            result.data.amountJson.forEach((amo) => {
              amo.amount = amo.amount / 100
              result.data.allAmount += amo.amount
            })
          }
          this.query = result.data
          this.getAllOpenShopList()
        } else {
          this.$toast('办卡单据已删除！')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.agreementWarp{
  width: 100%;
  >img{
    width: 100%;
  }
  .signature{
    width: 100%;
    z-index: 99;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background: #fff;
    overflow: hidden;
    .signatureBtn{
      float: right;
      line-height: 0px;
      >button{
        margin-right: 15px;
      }
    }
    >p{
      float: left;
      font-size: 16px;
      font-weight: 600;
      margin-left: 15px;
      line-height: 32px;
    }
    .noticeEsign{
      width: 667px;
      height: 240px;
    }
  }
}
.general{
  font-size: 14px;
  p{
    line-height: 20px;
    >span{
      margin-left: 5px;
      font-weight: 700;
    }
  }
  >p:nth-child(1){
    font-size: 18px;
    font-weight: 700;
    text-align: center;
  }
  .generalTitle{
    font-size: 14px;
    font-weight: 700;
    margin-top: 15px;
  }
  .checkboxItem{
    margin-top: 15px;
  }
}
.cardContent{
  border: 1px solid #cccccc;
  padding: 5px;
  border-radius: 8px;
  margin-bottom: 10px;
  .cardContent_item{
    display: flex;
    line-height: 20px;
    >p:nth-child(1){
      width: 80px;
      text-align: right;
    }
    >p:nth-child(2){
      font-weight: 400;
    }
  }
}
.shopWarp{
  margin-top: 15px;
  .title{
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }
  .shopContent{
    font-size: 14px;
    padding: 10px;
    border-top: 1px solid #ccc;
    >div{
      overflow: hidden;
      margin-bottom: 10px;
      >p:nth-child(1){
        float: left;
      }
      >p:nth-child(2){
        float: right;
      }
    }
    >p{
      color: #ccc
    }
  }
}
.cardDetali{
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}
.cardTable{
  display: flex;
  >p{
    width: 300px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-weight: normal;
    border: 1px solid #cccccc;
    background: #F1F1F6;
  }
  >p:nth-child(2){
    width: 150px;
  }
}
.cardTable_item{
  display: flex;
  >p{
    width: 300px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-weight: normal;
    border: 1px solid #cccccc;
  }
  >p:nth-child(2){
    width: 150px;
  }
}
.modelWarp{
  height: 667px;
  overflow-y: auto;
  text-align: center;
  position: relative;
  >img{
    width: 667px;
  }
  .modelBtn{
    width: 120px;
    margin: 10px 0;
  }
  .customerSign{
    width: 70px;
    height: 20px;
    position: absolute;
    bottom: -180px;
    left: 138px;
  }
  .cash{
    top: 218px !important;
    left: 175px !important;
  }
  .other{
    left: 383px !important;
    top: 218px !important;
  }
  .otherContent{
    width: 100px;
    text-align: left;
    top: 218px !important;
    left: 422px !important;
  }
  >p{
    font-size: 12px;
    z-index: 11;
    position: absolute;
    color: #000;
    font-weight: 700;
  }
  >p:nth-child(2){
    right: -280px;
    top: 25px;
  }
  >p:nth-child(3){
    left: 210px;
    top: 207px;
  }
  >p:nth-child(4){
    right: -50px;
    top: 207px;
  }
  >p:nth-child(5){
    right: -80px;
    top: 207px;
  }
  >p:nth-child(6){
    right: -110px;
    top: 207px;
  }
  >p:nth-child(7){
    left: 270px;
    top: 475px;
  }
  >p:nth-child(8){
    left: 111px;
    bottom: -192px;
  }
  >p:nth-child(9){
    left: 115px;
    bottom: -202px;
  }
  >p:nth-child(10){
    left: 160px;
    bottom: -202px;
  }
  >p:nth-child(11){
    left: 193px;
    bottom: -202px;
  }
}
</style>
